export class CaseManNoteAddCommand {
    constructor(
        public readonly caseId: string,
        public readonly noteText: string,
    ) {}
}